module.exports = __webpack_public_path__ + "img/activites-types.4a9038b1.svg";